import { actionTypes } from '../constants/actionTypes';
import { initialOrdersFilters } from '../initializeObjects/ordersFilters';

const ordersPageViewNumbers = [10, 25, 50, 100, 150, 200];

const initialPagination = {
  pages: [],
  pageSelected: 1,
  pageNext: false,
  pagePrevious: false,
  totalPages: 5
};

export const ordersFilters = (state = initialOrdersFilters, action) => {
  switch (action.type) {
    case actionTypes.ORDER_FILTERS:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const ordersPagination = (state = initialPagination, action) => {
  switch (action.type) {
    case actionTypes.ORDERS_PAGINATION:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const ordersList = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ORDERS:
      return [].concat(action.payload);
  }

  return state;
};

export const ordersViewsPerPage = (state = 10, action) => {
  switch (action.type) {
    case actionTypes.SET_ORDERS_PAGE_VEIW_SIZE:
      return action.payload;
  }

  return state;
};

export const ordersEventsNumber = (state = ordersPageViewNumbers, action) => {
  switch (action.type) {
    case actionTypes.ORDERS_PAGE_VIEW_NUMBERS:
      return action.payload;
  }

  return state;
};

export const printUrl = (state = '', action) => {
  switch (action.type) {
    case actionTypes.PRINT_URL:
      return action.payload;
  }
  
  return state;
};

export const permissionDisplayItems = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.PERMISSON_DISPLAY_ITEMS:
      return action.payload;
  }
  
  return state;
};
